<div class="hidden">
  <div id="map-legend" class="legend">
    <div><b>{{'nettopo.legend' | transloco}}</b></div>
    <div><span>- - - {{'model.communications' | transloco}}</span></div>
    <div><span class="dot" style="background-color: #03c211 !important;"></span>GW</div>
    <div><span class="dot" style="background-color: #acb900 !important;"></span>HUB</div>
    <div><span class="dot" style="background-color: #4264fb !important;"></span>DEVICE</div>
    <div><span class="dot" style="background-color: #42bafb !important;"></span>IMPORTED DEVICE</div>

<!--        <div *ngFor="let color of codeColors"><span [ngStyle]="['color', color.color]">-&#45;&#45;&#45;&#45;</span>{{color.id}}</div>-->

<!--            <div><span style="background-color: #b9babb"></span>{{'misc.map.OfflineNode' | transloco}}</div>-->
  </div>
</div>
<div class="grid" style="margin-top: 8px;">
  <div class="flex flex-column col-12 xl:col-6">
    <div class="card">

      <p-accordion>
        <p-accordionTab header="{{'nettopo.last7DaysCommunications' | transloco}}" [selected]="true">
          <p-skeleton *ngIf="pageLoading" width="100" height="515px"></p-skeleton>
          <app-generic-graph
            *ngIf="!pageLoading && communicationsGraphData"
            [data]="communicationsGraphData"
            [chartType]="'area'"
            [plotOptions]="{area: { stacking: 'normal'}, series: { connectNulls: true}}"
            [tooltipShared]="true"
            [customSeries]="true"
            [legend]="false"
            height="215"
            name="Value"
          ></app-generic-graph>
          <p-table *ngIf="!pageLoading && links" [value]="links" [scrollable]="true" scrollHeight="300px">
            <ng-template pTemplate="header">
              <tr>
                <th>{{'nettopo.node' | transloco}}</th>
                <th>{{'nettopo.totalCommunications' | transloco}}</th>
                <th>{{'nettopo.lastCommunication' | transloco}}</th>
                <th>{{'nettopo.distances' | transloco}}</th>
                <th>{{'nettopo.coverage' | transloco}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-edge>
              <tr>
                <td><span [ngStyle]="{'color': this.codeColors[edge.target].color}"> {{edge.target}} </span></td>
                <td>{{edge.communications}}</td>
                <td>{{edge.lastCommunication}} </td>
                <td>{{edge.distance}}</td>
                <td>{{edge.coverage}}</td>
              </tr>
            </ng-template>
          </p-table>
        </p-accordionTab>
        <p-accordionTab header="{{'nettopo.last7DaysLostFrames' | transloco}}">
          <app-generic-graph
            *ngIf="!pageLoading && totalPacketsGraphData"
            [data]="totalPacketsGraphData"
            [chartType]="'bar'"
            [plotOptions]="{series: {stacking: 'percent', dataLabels: {enabled:true}}}"
            [categories]="categories"
            [customSeries]="true"
            [legend]="false"
            height="100"
            name="Value"
          ></app-generic-graph>
          <app-generic-graph
            *ngIf="!pageLoading && lostFramesGraphData"
            [data]="lostFramesGraphData"
            [drillDown]="drillDownGraphData"
            [chartType]="'column'"
            [customSeries]="true"
            [legend]="false"
            height="415"
            name="Value"
          ></app-generic-graph>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
  <div class="col-12 xl:col-6">
    <div class="card">
      <div class="card-header pt-1">
        <h5 class="mb-1">{{'nettopo.communicationsMap' | transloco}} </h5>
        <p-selectButton [options]="layers" [ngModel]="selectedLayer" (onChange)="displayLayer($event.value)"></p-selectButton>
      </div>
      <hr style="margin-top: 0.75rem;">
      <p-skeleton *ngIf="pageLoading" width="100%" height="570px"></p-skeleton>
      <div [ngStyle]="{ 'height' : pageLoading ? '0px' : '570px' }" id="devTopoMap" class="rounded"></div>
    </div>
  </div>
</div>
